export default __webpack_public_path__ + "static/media/avatar_tiger2.87291601.mp3";